import { autobind } from 'core-decorators';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { isOffline, isOnline } from '/@/store/network/actions';

@connect(
    (state) => ({ offline: state.network.offline }),
    (dispatch) => bindActionCreators({ isOnline, isOffline }, dispatch)
)
@autobind
export default class NetworkCheck extends React.Component {
    async UNSAFE_componentWillMount() {
        window.addEventListener('online', async (e) => await this.handleCheckOnline());
        window.addEventListener('offline', async (e) => await this.handleCheckOnline());
    }

    async componentDidMount() {
        await this.handleCheckOnline();
    }

    componentWillUnmount() {
        window.removeEventListener('online', async (e) => await this.handleCheckOnline());
        window.removeEventListener('offline', async (e) => await this.handleCheckOnline());
    }

    async handleCheckOnline() {
        if (await this.isOnline()) this.props.isOnline();
        else this.props.isOffline();
    }

    async isOnline() {
        if (!window.navigator.onLine) return false;

        // avoid CORS errors with a request to your own origin
        const url = new URL(window.location.origin);

        // random value to prevent cached responses
        url.searchParams.set('rand', Math.random().toString(36).substring(2, 15));

        try {
            const response = await fetch(url.toString(), { method: 'GET' });
            return response.ok;
        } catch (error) {
            return false;
        }
    }

    render() {
        return null;
    }
}
